<template>
    <section id="content">
        <div class="content-wrap bg-grey credSection">
            <div class="container clearfix">
                <div class="row justify-content-center">
                    <!--<div class="col-lg-4">
                        <a href="javascript:void(0)" class="card card-body card-tenant">
                            <img :src="`${imgBase}Content/images/ic-employer-registration.svg`" />
                            <h2>{{$t("SignIn-EmployerAndTrainingCenter")}}</h2>
                        </a>
                    </div>-->
                    <div class="col-lg-4">
                        <a :href="applicantURL" target="_blank" class="card card-body card-tenant">
                            <img :src="`${imgBase}Content/images/ic-jobseeker.svg`" />
                            <h2>{{$t("SignIn-Applicant")}}</h2>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section><!-- #content end -->
</template>

<script>
    import * as registrationService from './Service/RegistrationService'
    export default {
        name: 'SignInComponent',
        data() {
            return { imgBase: process.env.BASE_URL, applicantURL: "" }
        },
        created() {
            registrationService.getRegistrationPath(this);
        }
    }

</script>
